import React, { useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3050';

function ForgotUsernameModal({ showNotification, setAuthView }) {
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            const res = await fetch(`${API_URL}/api/auth/forgot-username`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email })
            });
            const data = await res.json();
            if (!res.ok) throw new Error(data.message);
            showNotification(data.message, 'success');
            setAuthView('login');
        } catch (err) {
            showNotification(err.message, 'error');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="login-box">
            <div className="login-header">
                <svg className="logo" viewBox="0 0 100 100"><path d="M 10,90 L 50,10 L 90,90 Z" fill="#fff" /><path d="M 30,90 L 50,50 L 70,90 Z" fill="#a78bfa" /></svg>
                <h2>Forgot Username</h2>
                <p>Enter your company email to receive your username.</p>
            </div>
            <form onSubmit={handleSubmit}>
                <div className="input-group">
                    <label>Business Email</label>
                    <input type="email" value={email} onChange={e => setEmail(e.target.value)} required disabled={isLoading} />
                </div>
                <button type="submit" className="login-button" disabled={isLoading}>
                    {isLoading ? 'Sending...' : 'Send Usernames'}
                </button>
            </form>
            <div className="auth-switch">
                <p>Remembered? <button onClick={() => setAuthView('login')}>Sign In</button></p>
            </div>
        </div>
    );
}

export default ForgotUsernameModal;
